module.exports = __webpack_public_path__ + "static/media/GitHub-1.dd61a206.svg";